import { connect } from 'react-redux'
import { getCountryDict } from '../../../reducers/userObject/selectors/object'

const mapStateToProps = state => {
  return {
    countryDictionary: getCountryDict(state),
  }
}

export default connect(mapStateToProps)
